import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  private loadingMessageSubject = new BehaviorSubject<string>(
    'Chargement en cours...'
  );
  public loadingMessage$ = this.loadingMessageSubject.asObservable();

  setLoading(loading: boolean, message?: string): void {
    this.loadingSubject.next(loading);
    if (message) {
      this.loadingMessageSubject.next(message);
    }
  }

  isLoading(): boolean {
    return this.loadingSubject.value;
  }
}
